import React from "react";
// import Logo from "../../assets/logo.png";
import { STATIC_SRC } from "../../utils";
import banner5 from "assets/v5/banner5.png";
import banner4 from "assets/v4/banner4.png";
let devHost = STATIC_SRC;
if (~window.location.host.indexOf("sunshy")) {
  devHost = "";
}
let banner = banner4;

const Banner = ({ version }) => {
  if (version === 5) {
    banner = banner5;
  }
  return (
    <div className="banner-box">
      {/* <div className="title">会员优享专区</div> */}
      <div className="banner">
        <img src={`${devHost + banner + "?v=4"}`} alt={banner} />
      </div>
    </div>
  );
};
export default Banner;



// WEBPACK FOOTER //
// ./src/pages/getVip/Banner.jsx